module.exports = __webpack_public_path__ + "static/media/target.aac06a16.png";